import { useQuery } from '@tanstack/react-query';
import { fetchLocations } from 'src/models/location/location';
import { fetchServiceOptions } from 'src/models/service/service';
import { fetchTrainers } from 'src/models/user/user';

export const useManageSchedule = () => {
  const { data: trainers } = useQuery({
    queryKey: ['trainers'],
    queryFn: () => fetchTrainers(),
    staleTime: 60000,
    gcTime: 60000,
  });

  const { data: locations } = useQuery({
    queryKey: ['locations'],
    queryFn: () =>
      fetchLocations({ fetchAll: true, sort: 'name', sortDir: 'asc' }),
    staleTime: 60000,
    gcTime: 60000,
    select: (data) => data.locations,
  });

  const { data: services } = useQuery({
    queryKey: ['services', 'options'],
    queryFn: () => fetchServiceOptions(),
    staleTime: 60000,
    gcTime: 60000,
  });

  return { trainers, locations, services };
};
